export const trimText = (text, textLength = 255) => {
  if (typeof text !== 'string') {
    return '';
  }

  if (text.length <= textLength) {
    return text;
  }

  return `${text.slice(0, textLength)}...`;
};
